export default [
    {
        path: '/tienda-eliminada',
        meta: { nombre: 'Soporte' },
        name: 'tienda-eliminada',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/tiendaEliminada').then(m => m.default || m),
    }
]
